import { useState } from 'react';
import Checkbox from "../../../../Core/Fields/Floating/Checkbox";
const Tab6 = ({
  pageState,setPageState,handleChange,onInputChange,
  setDisable, disable,
  setDelivery, delivery,
  setFrozen, frozen,
  setSalerOrder, salesorder
}) => {
  return (
    <div>
      <div className="px-2 py-3" style={{ background: 'white' }}>
        <div style={{ display: 'flex' }} >
          <div className="col-md-12 px-2">
            <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Details</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <label style={{ height: '19px' }}></label>
                   <Checkbox
    id="AllowSalesInvoiceWithoutSalesOrder"
    label="Allow Sales Invoice Without Sales Order"
     value={pageState.salesorder || false}   // ✅ use value instead of checked
    onChange={(checked) => onInputChange("salesorder", checked)}
  />
                 

                </div>

                <div style={{ flex: 1 }}>
                  <label style={{ height: '19px' }}></label>
                 <Checkbox
    id=" IsFrozen"
    label="Is Frozen"
    value={pageState.frozen || false}   // ✅ use value instead of checked
    onChange={(checked) => onInputChange("frozen", checked)}
  />
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>

                <div style={{ flex: 1 }}>
                  <label style={{ height: '19px' }}></label>
                   <Checkbox
    id="AllowSalesInvoiceWithoutDeliveryNote"
    label="Allow Sales Invoice Without Delivery Note"
    value={pageState.delivery || false}   // ✅ use value instead of checked
    onChange={(checked) => onInputChange("delivery", checked)}
  />



                </div>
                <div style={{ flex: 1 }}>
                  <label style={{ height: '19px' }}></label>
                   <Checkbox
    id="Disabled"
    label="Disabled"
     value={pageState.disable || false}   // ✅ use value instead of checked
    onChange={(checked) => onInputChange("disable", checked)}
  />
                </div>
              </div>


            </div>
          </div>

          
        </div>
        
      </div>

    </div>
  );
};

export default Tab6;
